import { useState } from "react";
import {
  PanelListHeader,
  STUDY_FILTERS,
  StudyTable,
  type StudyFilter,
} from "@/components/devicePanel/PanelWorklist";
import { siteOrder } from "@/types/notificationView";
import { panelCaseUrl, type DevicePanelStudiesResponse } from "@/types/devicePanel";

/**
 * A notification-view panel's studies as the site's worklist, flagged studies
 * first. Each row opens the study's notification page.
 */
export function SiteWorklist({ data }: { data: DevicePanelStudiesResponse }) {
  const [filter, setFilter] = useState<StudyFilter>("All");
  const { panel } = data;
  const shown = siteOrder(data.studies).filter(STUDY_FILTERS[filter]);
  return (
    <div className="flex h-full flex-col bg-bg text-fg">
      <PanelListHeader
        panel={panel}
        studies={data.studies}
        filters={Object.keys(STUDY_FILTERS) as StudyFilter[]}
        filter={filter}
        onFilter={setFilter}
      />
      <div className="min-h-0 flex-1 overflow-auto">
        <StudyTable
          panelId={panel.id}
          rows={shown}
          devices={panel.devices}
          caseUrl={(row) => panelCaseUrl(panel.id, row.study_uid)}
        />
        {shown.length === 0 && (
          <p className="px-4 py-3 text-[13px] text-fg-dim">
            {filter === "Flagged" ? "No flagged studies" : "No studies"}
          </p>
        )}
      </div>
    </div>
  );
}
